import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import ModalFile from '../../Partials/ModalFileFichas';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import {showModalPageClass, hideLoader, hideModalPageClass, setTextInputLongitud, generateSlugAutomatico, setDataForm} from '../../../functions';
import axios from 'axios';
import Error from '../../Error/error';
import {BASE_URL_PRODUCTOS} from '../../../constants';
import { cacheConfig, generateLabel, getFrontPageUrl } from '../../../utils/functions';

import CKEditor from 'ckeditor4-react';
import { ckeditorconfig } from '../../functions/functions';

export default class FichaProductoEditar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fichaPartida: {
                "part_Id": 0,
                "part_Codigo": "",
                "part_Descripcion": "",
                "part_Producto": "",
                "part_EstadoPublico": "",
                // "part_Slug": "",
                "part_FobUltimoAnio": null,
                "part_UltimoAnio": null,
             
                "usuarioCreacion  ": "",
                "usuarioEdicion  ": "",
                "usuarioEliminacion": "",
                "fechaCreacion": "",
                "fechaEdicion": "",
                "fichaIntroContent": "",
                "fichaPieContentTitle": "",
                "fichaPieContent": "",
             
                // "part_TituloSEO": "",
                // "part_DescripcionSEO": "",
                // "part_EnlaceSEO": "",
                // "part_Script": "",
                // "part_ImagenSEO": "",
                // "part_SeguirBuscadoresSEO": "",
                // "part_MostrarBuscadoresSEO": "",
                // "imagenSEO": "",
                // "imagenSEOData": ""
            },
            titulos: [],
            Validacion: {
                part_Codigo: {
                    Error: false,
                    RequeridoError: "El campo Código de partida es requerido."
                },
                part_Descripcion: {
                    Error: false,
                    RequeridoError: "El campo Descripcion es requerido."
                },
                // part_Slug: {
                //     Error: false,
                //     RequeridoError: "El campo Slug es requerido."
                // }
                  
            },
            key: "0",
            guardando: false,
            response:   [], 
            loadData:   true,
            // miniaturaImagenSEO: "",
            // part_Descripcion:"",
        }
        // this.handleChange       = this.handleChange.bind(this);
        this.handleInputChange  = this.handleInputChange.bind(this);
        // this.onEditorChange     = this.onEditorChange.bind(this);
    }

    // deleteCache = (slug, partidaCodigo) => {
        // const baseUrl   = getFrontPageUrl();
        // // const urldeleteCache = `${baseUrl}/cache/limpiar-ficha-partida?slug=${slug}&part_Id=${part_Id}`;
        // const urldeleteCache = `${baseUrl}/cache/limpiar-ficha-partida?&partidaCodigo=${partidaCodigo}`;
        // axios.delete(
        //     urldeleteCache, 
        //     cacheConfig
        // ).then((res) => {
        //     // console.log(res.data);
        //     // console.log(res.data.message);

        // }).catch((err) => {
        //     console.error(err);
        // });
    // }

    handleClickGuardar(e) {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = `${API_URL}FichaPartidaUX/Actualizar`;
            // const url = `https://localhost:5004/api/FichaPartidaUX/Actualizar`;
            
            let fichaPartida = {...this.state.fichaPartida};
            
            setDataForm(fichaPartida);
            
            fichaPartida["usuarioCreacion"] = cookie.load('user').nUsuCodigo;
            fichaPartida['part_EstadoPublico'] = fichaPartida['part_EstadoPublico']; 

            let newState = this.state;
            let hasError = false;
            
            if (!fichaPartida.part_Codigo || fichaPartida.part_Codigo == '') {
                newState.Validacion.part_Codigo.Error = true;
                toast.error(newState.Validacion.part_Codigo.RequeridoError);
                hasError = true;
            }
            
            // if (!fichaPartida.part_Slug || fichaPartida.part_Slug == '') {
            //     newState.Validacion.part_Slug.Error = true;
            //     toast.error(newState.Validacion.part_Slug.RequeridoError);
            //     hasError = true;
            // }
            
            if (!fichaPartida.part_Descripcion || fichaPartida.part_Descripcion == '') {
                newState.Validacion.part_Descripcion.Error = true;
                toast.error(newState.Validacion.part_Descripcion.RequeridoError);
                hasError = true;
            }
            
            if(hasError){
                this.setState(newState);
                return;
            }

            // const slug       = fichaPartida.part_Slug;
		    const part_Id    = fichaPartida.part_Id;
            // this.deleteCache(slug, part_Id);
            console.log(fichaPartida)
            axios.post(url, JSON.stringify(JSON.stringify(fichaPartida)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                me.setState({ guardando:false });
                if (data.data.result)
                    // console.log("data.data.result", data.data.result)
                    if(data.data.result.status){
                        // this.deleteCache(slug, part_Id);
                        this.props.history.push({
                            pathname: '/ficha-partida'
                        });
                    }else{
                        console.log("Err1:" ,data.data.result.error)
                        toast.error(data.data.result.error);
                    }
            }).catch((error)=> {
                console.log("Err0:" ,error)
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    // handleChange(e) {
    //     this.setState({ sectorCargado: e.target.value });
    // }

    handleClickCancel(e) {
        this.props.history.push({
            pathname: '/ficha-partida'
        });
    }

    // showModalFile = (clase = "") => {
    //     showModalPageClass(clase);
    // }

    // onSelectArchivo(fileName, fileData, fieldName, fieldNameData){
    //     let fichaPartida = {... this.state.fichaPartida};

    //     fichaPartida[fieldName] = fileName;
    //     fichaPartida[fieldNameData] = fileData;
        
    //     document.getElementById(fieldName).value = fileName;

    //     this.setState({
    //         fichaPartida
    //     });

    //     if(fieldName == 'imagenSEO'){
    //         this.setState({
    //             miniaturaImagenSEO: fileData
    //         });
    //     }

    //     hideModalPageClass(`div${fieldName}Upload`);
    // }

    checkedValidate = (item) => {
        let fichaPartida = this.state.fichaPartida;
        fichaPartida[item] = !fichaPartida[item];

        this.setState({
            fichaPartida: fichaPartida
        });
    }

    onTituloChange(){
        let nombreProductoVal = document.getElementById('part_Codigo').value;

        let validaciones = this.state.Validacion;
        validaciones['part_Descripcion'].Error = false;
        // validaciones['part_Slug'].Error = false;

        this.setState({
            Validacion: validaciones
        });

        // document.getElementById('part_TituloSEO').value = nombreProductoVal;
        // document.getElementById('part_Slug').value = generateSlugAutomatico(nombreProductoVal);
        // document.getElementById('part_EnlaceSEO').value = generateSlugAutomatico(nombreProductoVal);
        // setTextInputLongitud(['part_Codigo', 'part_Descripcion', 'part_Producto', 'part_Slug', 'part_EnlaceSEO', 'part_TituloSEO', 'part_DescripcionSEO', 'part_Script']);
        setTextInputLongitud(['part_Codigo', 'part_Descripcion', 'part_Producto']);
    }

    handleInputChange(event){
        // const target = event.target;
        // const value = target.type === 'checkbox' ? target.checked : target.value;

        // if(target.id == 'part_Slug' || target.id == 'part_Codigo'){
        //     let validaciones = this.state.Validacion;
        //     validaciones[target.id].Error = false;
        //     this.setState({
        //         Validacion: validaciones
        //     });
        // }else{
        //     if(value) this.setState({ partidaSeleccionada: value.value });
        // }
    }


    getTitulos(){
        const url = `${API_URL}ParametroUX/ListarParametrosPorCodigo/FPDT`;
        axios.get(url).then((res) => {
            const data = res.data.result;
            this.setState({
                titulos: data
            });

        }).catch((err) => {
            console.error(err);
        });
        
    }

    componentDidMount(){
        localStorage.setItem("load", false);

        let params = this.props.match.params;
        var key = params.id;
        this.state.key = key;

        this.getTitulos();

        const url = `${API_URL}FichaPartidaUX/ObtenerPorId?id=${key}`;
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                
                let dataficha = data.result.data;
                //  console.log(dataficha);
                
                dataficha['part_EstadoPublico'] = Boolean(dataficha['part_EstadoPublico'] === '1');

                this.setState({ 
                    fichaPartida: dataficha,
                    response:   data, 
                    loadData:   false,
                    // miniaturaImagenSEO: data.result.data.imagenSEO ? data.result.data.imagenSEO : ""
                });
                
                setTimeout(() => {
                    // setTextInputLongitud(['part_Codigo', 'part_Descripcion', 'part_Producto', 'part_Slug', 'part_EnlaceSEO', 'part_TituloSEO', 'part_DescripcionSEO', 'part_Script']);
                    setTextInputLongitud(['part_Codigo', 'part_Descripcion', 'part_Producto']);
                }, 200);
                
            })
            .catch(error => {
                hideLoader();
                console.log("Error al obtener la partida: ", error);
                toast.error('Error al obtener el partida');
            });

    }

    onEditorChange( editor, flag ) {
        let copyState   = this.state.fichaPartida;
        copyState[flag] = editor.editor.getData();
        this.setState({
            fichaPartida: copyState
        });
    }

    render() {
        const { part_Descripcion, fichaIntroContent,fichaPieContentTitle, fichaPieContent } = this.state.fichaPartida;
        const { titulos } = this.state;
        // console.log(this.state.fichaPartida);

        return (
            (this.state.response.statusCode === 200 && !this.state.loadData)?
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <Link to="/ficha-partida">
                            / Ficha Partidas
                        </Link>
                        <span> / Editar Ficha Partida</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Ficha de Partida 
                </div>
                <div className="div_Modulos_Noticias">
                    <div className="div_WrapperEditarPagina">
                            CODIGO DE PARTIDA (10 caracteres): 
                            <div className="txtFile x-1">
                            <input id='part_Codigo' type="text" placeholder="Codigo de partida (10 caracteres)" maxLength={10} 
                                className={`data-test data-form ${this.state.Validacion.part_Codigo.Error ? "error" : ""} `} 
                                defaultValue={this.state.fichaPartida.part_Codigo}
                                style={{background:'#d8d8d8'}}
                                onChange={() => this.onTituloChange()} 
                            />
                            <span id="longitudpart_Codigo"></span>
                        </div>
                        {/* <div className="txtFile x-1">
                            <input type="text" placeholder="Slug" id='part_Slug' maxLength={100} className={`data-test data-form ${this.state.Validacion.part_Slug.Error ? "error" : ""}`}
                            onChange={this.handleInputChange} defaultValue={this.state.fichaPartida.part_Slug}
                            />
                            <span id="longitudpart_Slug"></span>
                        </div> */}
                        <div className="txtFile x-1">
                            DESCRIPCIÓN DE PARTIDA: 
                            <textarea placeholder="Descripción" id='part_Descripcion' maxLength="500" style={{height:"100px"}} defaultValue={this.state.fichaPartida.part_Descripcion} className="data-test data-form"/>
                            <span id="longitudpart_Descripcion"></span>
                      </div>
                        <div className="txtFile x-1">
                            NOMBRE DE PRODUCTO ASOCIADO: 
                            <input type="text" placeholder="Nombre de producto" id='part_Producto'  maxLength={500}  className="data-test data-form "
                            defaultValue={this.state.fichaPartida.part_Producto} />
                            <span id="longitudpart_Producto"></span>
                            </div>
                        <div className="txtFile x-1">
                            Valor FOB último año: 
                            <input type="text" title="Valor FOB" id='part_FobUltimoAnio' maxLength={10} readOnly style={{background:'#d8d8d8'}}
                                // onChange={this.handleInputChange} 
                                defaultValue={this.state.fichaPartida.part_FobUltimoAnio}/> 
                                <span id="longitudpart_FobUltimoAnio"></span>
                        </div>
                        <div className="txtFile x-1">
                            Último año: 
                            <input type="text" title="Último año del FOB" id='part_UltimoAnio' maxLength={4} readOnly style={{background:'#d8d8d8'}}
                                // onChange={this.handleInputChange} 
                                defaultValue={this.state.fichaPartida.part_UltimoAnio}/> 
                                <span id="longitudpart_UltimoAnio"></span>
                        </div>
                        <div className="divWrapperActive">
                            <div>
                                <span>Habilitado:</span>
                            </div>
                            <div>
                                <div className={this.state.fichaPartida.part_EstadoPublico ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("part_EstadoPublico")}>
                                    <div className={this.state.fichaPartida.part_EstadoPublico ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>{this.state.fichaPartida.part_EstadoPublico ? "Activado" : "Desactivado"}</span>
                            </div>
                        </div>
                        
                    </div>

                    <div className="clear"></div>
{/* 
                    <div className="divModulo_Seo">
                        <h2>Configuración <strong>SEO</strong></h2>
                        <div className="divWrapperModulo_Seo">
                            <div className="txtFile x-1">
                                <input type="text" placeholder="SEO Título" id='part_TituloSEO' defaultValue={this.state.fichaPartida.part_TituloSEO} maxLength="255" className="data-test data-form"/>
                                <span id="longitudpart_TituloSEO"></span>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="SEO Descripción" id='part_DescripcionSEO' maxLength="255" style={{height:"100px"}} defaultValue={this.state.fichaPartida.part_DescripcionSEO} className="data-test data-form"/>
                                <span id="longitudpart_DescripcionSEO"></span>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" onClick={() => this.showModalFile("divImagenSEOUpload")} />
                                <input type="text" placeholder="SEO Imagen" id='imagenSEO' defaultValue={this.state.fichaPartida.imagenSEO} className="data-test data-form"/>
                            </div>
                            <div className="col-md-6 p-2 text-center">
                                <div className="section__margin-bottom">
                                    {!this.state.miniaturaImagenSEO
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaImagenSEO.startsWith('http') || this.state.miniaturaImagenSEO.startsWith('data:image')) ? this.state.miniaturaImagenSEO : (BASE_URL_PRODUCTOS + this.state.miniaturaImagenSEO)} />
                                            <br/><br/>  
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Enlace SEO" id='part_EnlaceSEO' maxLength="255" defaultValue={this.state.fichaPartida.part_EnlaceSEO} className="data-test data-form"/>
                                <span id="longitudpart_EnlaceSEO"></span>
                            </div>

                            <div className="col-md-6 p-2 text-center">
                                <div className="section__margin-bottom">
                                    {!this.state.miniaturaImagenSEO
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaImagenSEO.startsWith('http') || this.state.miniaturaImagenSEO.startsWith('data:image')) ? this.state.miniaturaImagenSEO : (BASE_URL_PRODUCTOS + this.state.miniaturaImagenSEO)} />
                                            <br/><br/>  
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="divWrapperActive">
                                <div>
                                    <span>Motores de busqueda <br />seguir enlaces</span>
                                </div>
                                <div>
                                    <div className={this.state.fichaPartida.part_SeguirBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("part_SeguirBuscadoresSEO")}>
                                        <div className={this.state.fichaPartida.part_SeguirBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaPartida.part_SeguirBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                                <div>
                                    <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                                </div>
                                <div>
                                    <div className={this.state.fichaPartida.part_MostrarBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("part_MostrarBuscadoresSEO")}>
                                        <div className={this.state.fichaPartida.part_MostrarBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaPartida.part_MostrarBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="Pegue aquí su código JavaScript" id="part_Script" style={{height:"100px"}} maxLength="32000" defaultValue={this.state.fichaPartida.part_Script} className="data-test data-form"/>
                                <span id="longitudpart_Script"></span>
                            </div>
                        </div>
                    </div> */}


                    <div className="divModulo_Seo">
                        <h2> <strong>Contenidos para la Ficha de Producto (SEO)</strong></h2>
                        <div className="divWrapperModulo_Seo">

                            <div className="boletin__filters section__margin-bottom">
                                 TEXTO: INTRODUCCIÓN PARA LA FICHA: 
                                <CKEditor
                                    data={fichaIntroContent ? fichaIntroContent : ""}
                                    onChange={(editor) => this.onEditorChange(editor, 'fichaIntroContent')}
                                    config={ckeditorconfig}
                                    placeholder="Texto intro para la partida"
                                    />
                                {/* {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_PRESENTACIONES').valor) : ""} */}
                                <span id="longitudpart_Script1"></span>
                            </div>


                            <div className="txtFile x-1">
                                 TITULO PARA: TEXTO CIERRE PARA LA FICHA: 
                                <input type="text" placeholder="Título del módulo pie de la Ficha" id='fichaPieContentTitle' defaultValue={fichaPieContentTitle} maxLength="50" className="data-test data-form"/>
                                <span id="longitudfichaPieContentTitle"></span>
                            </div>
                           
                            <div className="boletin__filters section__margin-bottom" >
                                 TEXTO: CIERRE PARA LA FICHA: 
                                <CKEditor
                                    data={fichaPieContent ? fichaPieContent : ""}
                                    onChange={(editor) => this.onEditorChange(editor, 'fichaPieContent')}
                                    config={ckeditorconfig}
                                    placeholder="Ingrese texto para el pie de la Ficha"
                                    />
                                {/* {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_PRESENTACIONES').valor) : ""} */}
                                <span id="longitudpart_Script3"></span>
                            </div>


                        </div>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#" className="btnActivo" onClick={(event) => this.handleClickGuardar(event)}>{this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}</a>
                        <a href="#" onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                {/* <ModalFile class={"divImagenSEOUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "imagenSEO", "imagenSEOData")} tipo="image"
                    helpText="La imagen debe tener una relacion de aspecto recomendada de: 13:9 Por ejemplo: 520 × 360 px"/> */}
            </div>
            :
            
            <Error StatusCode="500" StatusMessage="Error"></Error>
        )
    }
}